/**
 *  @author => @RMT_FRONT_CORE/CLI
 * */
import React from 'react';
import settings from 'config/constants';
import { Redirect } from 'react-router-dom';

const GrmtLandingRedirect = React.lazy(() => import('./views/pages/LandingRedirect'));
const OperationsPage = React.lazy(() => import('./views/pages/OperationsDashboard'));

const subUrl = settings.PRODUCTS.GRMT.path;

type Route = {
    path: string,
    name: string,
    exact: boolean,
    page: Function,
    subRoutes?: Array<Route>,
}
const ROUTES: Array<Route> = [
    { path: `/${subUrl}`, name: 'GRMT', exact: true, page: GrmtLandingRedirect },
    { path: `/${subUrl}/dashboard/main`, name: 'Main Dashboard', exact: true, page: () => <Redirect to={`/${subUrl}`} /> },
    { path: `/${subUrl}/dashboard/operations`, name: 'Operations Dashboard', exact: true, page: OperationsPage }
];

export default ROUTES;
